import { Input } from '@builder.io/sdk';

import { idField } from 'utils/builder/fields';

const accordionItemFields = [
  idField,
  {
    name: 'label',
    type: 'string',
    defaultValue: 'Your Question',
    helperText: 'Question/title shown in the accordion header.',
  },
  {
    name: 'description',
    type: 'richText',
    defaultValue: '<p>Your answer to the question</p>',
    helperText: 'Answer content displayed when expanded. Supports rich text, links, and basic formatting.',
  },
] as const satisfies DeepReadonly<Input[]>;

const moleculeAccordionFields = [
  {
    name: 'accordionItems',
    type: 'list',
    subFields: accordionItemFields,
    helperText: 'Add one or more Q&A items. Drag to reorder; order here is the display order.',
  },
  {
    name: 'hasFaqSchema',
    type: 'boolean',
    defaultValue: false,
    helperText:
      'Adds JSON-LD FAQPage schema generated from the items. Enable once per page where this component appears.',
  },
] as const satisfies DeepReadonly<Input[]>;

export type AccordionItemConfigProps = GenerateBuilder<typeof accordionItemFields>;
export type AccordionConfigProps = GenerateBuilder<typeof moleculeAccordionFields>;

export default moleculeAccordionFields;
